// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2

export const DEFAULT_MINUTES_DIFFERENCE = 30;
export const MAX_CHARACTERS_TITLE = 255;
export const MAX_CHARACTERS_PASSWORD = 255;
export const MAX_CHARACTERS_DESCRIPTION = 4096;
